module.exports = __webpack_public_path__ + "static/media/logo-itau.2f25759d.png";